<template>
    <div>
        <!-- <vs-alert icon-pack="feather" icon="icon-alert-circle" :active="userFormError" color="danger" class="pl-2 mb-4">
          Le formulaire ci-dessous contient des erreur, l'enregistrement n'a pas été effectué.
        </vs-alert> -->
        <vs-card class="py-4 px-0 mb-8" :class="{'loader': userLoading }" v-if="userForm">
            <!-- Identité -->
            <section class="vx-row px-4 items-start">
                <div class="vx-col hidden lg:block lg:w-1/5">
                    <div class="account-section-icon"></div>
                </div>
                <div class="vx-col lg:w-4/5">
                    <h4 class="text-2xl mb-2">Identité</h4>
                    <h6 class="text-muted text-sm mb-6">Utilisez ce formulaire pour mettre à jour vos informations
                        personnelles.</h6>
                    <div class="vx-row mb-2 items-center">
                        <div class="vx-col sm:w-2/12 w-full mb-2">
                            <span>Genre</span>
                        </div>
                        <div class="vx-col sm:w-2/12 w-full mb-2">
                            <select name="gender" v-model="userForm.gender">
                                <option v-for="option in genderOptions" :key="option" :value="option">{{
                                        option
                                    }}
                                </option>
                            </select>
                        </div>
                        <div class="vx-col sm:w-2/12 w-full">
                            <span>Fonction</span>
                        </div>
                        <div class="vx-col sm:w-6/12 w-full mb-2">
                            <vs-input class="w-full" v-model="userForm.job" placeholder="Fonction"/>
                        </div>
                    </div>
                    <div class="vx-row mb-2 items-center">
                        <div class="vx-col sm:w-2/12 w-full mb-2">
                            <span>Prénom</span>
                        </div>
                        <div class="vx-col sm:w-4/12 w-full mb-2">
                            <vs-input
                                :danger="isInvalid(userForm.firstname)"
                                danger-text="Vous devez saisir un prélastname valide"
                                val-icon-danger="icon-x"
                                val-icon-pack="feather"
                                name="firstname"
                                class="w-full"
                                icon-pack="feather"
                                icon="icon-user"
                                v-model="userForm.firstname"
                                placeholder="Prénom"/>
                        </div>
                        <div class="vx-col sm:w-2/12 w-full mb-2">
                            <span>Nom</span>
                        </div>
                        <div class="vx-col sm:w-4/12 w-full mb-2">
                            <vs-input
                                :danger="isInvalid(userForm.lastname)"
                                danger-text="Vous devez saisir un lastname valide"
                                val-icon-danger="icon-x"
                                val-icon-pack="feather"
                                class="w-full"
                                icon-pack="feather"
                                icon="icon-user"
                                v-model="userForm.lastname"
                                placeholder="Nom"/>
                            <span class="text-danger text-sm" v-show="errors.has('userForm.lastname')">{{
                                    errors.first('userForm.lastname')
                                }}</span>
                        </div>
                    </div>
                    <div class="vx-row mb-2 items-center">
                        <div class="vx-col sm:w-2/12 w-full mb-2">
                            <span>Email</span>
                        </div>
                        <div class="vx-col sm:w-4/12 w-full mb-2">
                            <vs-input
                                :danger="isInvalid(userForm.email, 'email')"
                                danger-text="Vous devez saisir un email valide"
                                val-icon-danger="icon-x"
                                val-icon-pack="feather"
                                type="email"
                                icon-pack="feather"
                                icon="icon-mail"
                                class="w-full"
                                v-model="userForm.email"
                                placeholder="Email"
                            />
                        </div>
                        <div class="vx-col sm:w-2/12 w-full mb-2">
                            <span>Téléphone</span>
                        </div>
                        <div class="vx-col sm:w-4/12 w-full mb-2">
                            <vs-input
                                :danger="isInvalid(userForm.telephone, 'tel')"
                                danger-text="Vous devez saisir un téléphone valide"
                                val-icon-danger="icon-x"
                                val-icon-pack="feather"
                                type="phone"
                                class="w-full"
                                icon-pack="feather"
                                icon="icon-phone"
                                v-model="userForm.telephone"
                                placeholder="tel"/>
                        </div>
                    </div>
                    <div class="vx-row mb-2 items-center">
                        <div class="vx-col sm:w-2/12 w-full mb-2">
                            <span>Avatar</span>
                        </div>
                        <div class="vx-col sm:w-8/12 w-full flex mb-2">
                            <div class="flex items-center">
                                <user-avatar :size="40" :src="userForm.avatar" class="mr-3"/>
                                <div class="upload-btn" v-if="!userAvatarLoading">
                                    <input class="imputFile" type="file" id="file" ref="file" name="file"
                                           accept=".jpg, .jpeg, .png" @change="handleUpload($event)">
                                    <label class="vs-component vs-button vs-button-primary vs-button-border" for="file">
                                        <i class="far fa-upload"
                                           style="order: 0; margin-right: 5px; margin-left: 0px;"></i>
                                        <span>Choisir une image</span>
                                    </label>
                                </div>
                                <div v-else class="fa-2x text-center px-20">
                                    <i class="fas fa-spinner fa-spin text-success"></i>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <vs-divider class="my-2" v-if="activeUser.role !== 'admin'"/>

            <section class="p-4" v-if="activeUser.role !== 'admin'">
                <h4 class="text-2xl mb-2">Coordonnées</h4>
                <h6 class="text-muted text-sm mb-6">Indiquez l'adresse de votre entreprise</h6>
                <div class="vx-row mb-2 items-center">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                            :danger="this.activeUser.role !== 'admin' ? isInvalid(userForm.client.name) : false"
                            danger-text="Vous devez saisir un nom de société"
                            val-icon-danger="icon-x"
                            val-icon-pack="feather"
                            label="Société"
                            class="w-full"
                            icon-no-border
                            v-model="userForm.client.name"
                            placeholder="Société"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input label="Site web" class="w-full" v-model="userForm.client.website" placeholder="Site web"/>
                    </div>
                </div>
                <div class="vx-row mb-2 items-center">
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input
                            :danger="this.activeUser.role !== 'admin' ? isInvalid(userForm.client.address1) : false"
                            danger-text="Vous devez saisir une adresse"
                            val-icon-danger="icon-x"
                            val-icon-pack="feather"
                            label="Adresse 1"
                            class="w-full"
                            v-model="userForm.client.address1"
                            placeholder="address1"/>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-2">
                        <vs-input label="Adresse 2" class="w-full" v-model="userForm.client.address2" placeholder="address2"/>
                    </div>
                </div>
                <div class="vx-row mb-4 items-center">
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                            :danger="this.activeUser.role !== 'admin' ? isInvalid(userForm.client.postal_code, 'code_postal') : false"
                            danger-text="Vous devez saisir un code postal"
                            val-icon-danger="icon-x"
                            val-icon-pack="feather"
                            label="Code
              postal"
                            class="w-full"
                            v-model="userForm.client.postal_code"
                            placeholder="Code postal"/>
                    </div>
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                            :danger="this.activeUser.role !== 'admin' ? isInvalid(userForm.client.city) : false"
                            danger-text="Vous devez saisir une city"
                            val-icon-danger="icon-x"
                            val-icon-pack="feather"
                            label="Ville"
                            class="w-full"
                            v-model="userForm.client.city"
                            placeholder="Ville"/>
                    </div>

                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input type="phone" label="Téléphone société" class="w-full" v-model="userForm.client.phone"
                                  placeholder="Téléphone société"/>
                    </div>
                </div>
            </section>
            <div slot="footer">
                <vs-row vs-justify="flex-end" class="mt-10 pb-8 pr-4">
                    <vs-button :disabled="userFormError" type="gradient" color="success" icon-pack="feather"
                               icon="icon-save" @click="onUpdateProfile">
                        Enregistrer
                    </vs-button>
                </vs-row>
            </div>
        </vs-card>
    </div>
</template>

<script>
import _ from 'lodash'
import {mapState, mapActions} from 'vuex'
import UserAvatar from '@/components/UserAvatar'
import {formValidationMixins} from '@/mixins/formValidationMixins.js'

export default {
  name: 'UserProfileForm',
  mixins: [formValidationMixins],
  components: {
    UserAvatar
  },
  data () {
    return {
      avatarFile: '',
      genderOptions: [
        'M',
        'Mme',
        'Autre'
      ],
      userForm: {
        gender: 'M',
        job: '',
        lastname: '',
        firstname: '',
        email: '',
        telephone: '',
        avatar: '',
          client: {
          name: '',
          website: '',
          address1: '',
          address2: '',
          postal_code: '',
          city: '',
          phone: ''
        }
      }
    }
  },
  computed: {
    ...mapState({
      userLoading: state => state.user.userLoading,
      userAvatarLoading: state => state.user.userAvatarLoading,
      activeUser: state => state.user.activeUser,
      userFormError () {
        const userFormInvalid = (this.isInvalid(this.userForm.firstname) || this.isInvalid(this.userForm.lastname) || this.isInvalid(this.userForm.email, 'email') || this.isInvalid(this.userForm.telephone, 'tel'))
        const coordinateFormInvalid = (this.isInvalid(this.userForm.client.name) || this.isInvalid(this.userForm.client.address1) || this.isInvalid(this.userForm.client.postal_code, 'code_postal') || this.isInvalid(this.userForm.client.city))

        return this.activeUser.role === 'admin' ? userFormInvalid : (userFormInvalid || coordinateFormInvalid)
      }
    })
  },
  created () {
    this.refreshUserInfos()
  },
  methods: {
    ...mapActions('user', ['getUser', 'updateUser', 'updateUserAvatar']),
    refreshUserInfos () {
      this.getUser(this.activeUser.id).then(() => {
        this.userForm = _.cloneDeep(this.activeUser)
      })
    },
    onUpdateProfile () {
      if (!this.userFormError) {
        this.updateUser(this.userForm).then(() => {
          // console.log(res)
        })
      }
    },
    handleUpload (e) {
      // console.log(e.target.files[0])
      if (e.target.files[0].name) {
        this.updateUserAvatar({id: this.activeUser.id, avatar: e.target.files[0]}).then(() => {
          this.refreshUserInfos()
        })
      }
    }
  }
}
</script>

<style lang="scss">

.upload-modal .vs-popup {
    width: 282px;
}

.account-section-icon {
    background: url('~@/assets/images/icons/section-user-icon.svg') no-repeat right center;
    height: 100%;
    min-height: 178px;
    width: calc(100% + 2.15rem);
    max-width: 170px;
    margin: -1.65rem -1.6rem -.4rem;
    border-radius: 8px 0 0 0;
}

.upload-btn {
    background-color: #fff;

    .imputFile {
        width: 0.1px;
        height: 0.1px;
        opacity: 0;
        overflow: hidden;
        position: absolute;
        z-index: -1;
    }
}

</style>
